import React from 'react';
import { observer } from 'mobx-react-lite';
import { NoItemInfo } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Pending/AutomaticWithdrawalsPending/AutomaticWithdrawalsPending.style';
import {
    GridHeaderRow,
    GridItem,
    GridBody,
} from 'src/components/FraudAndCompliance/AutomaticWithdrawals/CommonParts/GridRow.style';
import { RulesRow } from 'src/components/FraudAndCompliance/AutomaticWithdrawals/Processed/RulesRow';
import { RuleType } from 'src/AppState/AutomaticWithdrawalState';
import Loading from 'src/components/Loading';
import { useAppStateContext } from 'src/AppState/AppState';
import { ModelsState } from 'src/AppState/Models/ModelsState';

const renderList = (list: Array<number>, selectedTab: RuleType, models: ModelsState): Array<React.ReactNode> => {
    const elements: Array<React.ReactNode> = [];

    for (const ruleId of list) {
        elements.push(
            <RulesRow
                key={ruleId}
                ruleId={ruleId}
                selectedTab={selectedTab}
                models={models}
            />
        );
    }

    return elements;
};

interface RulesTabTabPropsType {
    selectedTab: RuleType;
    listRules: Array<number> | null;
}

export const RulesTab = observer((props: RulesTabTabPropsType) => {
    const { models } = useAppStateContext();

    const { listRules, selectedTab } = props;
    const amountOrReject = selectedTab === 'approve' ? 'Amount' : 'Reason to Reject';

    const infoTab = {
        approve: 'approved',
        reject: 'rejected',
    };

    if (listRules === null) {
        return (
            <Loading
                message='Loading...'
                active={true}
            />
        );
    }
    if (listRules.length === 0) {
        return <NoItemInfo>There are currently no {infoTab[selectedTab]} rules</NoItemInfo>;
    }

    return (
        <>
            <GridHeaderRow>
                <GridItem>Account Number</GridItem>
                <GridItem>Card</GridItem>
                <GridItem>Name</GridItem>
                <GridItem>{amountOrReject}</GridItem>
                <GridItem>Review</GridItem>
            </GridHeaderRow>
            <GridBody>{renderList(listRules, selectedTab, models)}</GridBody>
        </>
    );
});
